<template>
  <div class="student_box student_bg">
    <header class="flex-align-between student-head">
      <img class="student-logo" src="@/assets/student/student-logo.png">

      <div class="flex-align-center back-box">
        <!-- <img alt="" class="back-ico" src="@/assets/student/back-ico.png">
        <span class="back-text">返回</span> -->
        <div class="logout" v-if="fileList.length == 0" @click="logout">退出</div>
      </div>
    </header>
    <!-- !UploadStatus &&  -->
    <div class="student-Entrance" v-show="fileList.length == 0 && !uploadReady">
      <div class="flex-align-center">
        <div class="student-class-name flex-align-between">
          <div class="dot"></div>
          <div>互动测评</div>
          <div class="dot"></div>
        </div>
      </div>

      <div class="class-name flex-align-center">
        <span>{{ $route.query.className }}</span><span>{{ $route.query.studentName }}</span>
      </div>

      <div class="flex-column-center ty-box">
        <img alt="" class="ty-button" src="@/assets/student/ty-button.png" @click="goUpload">
        <img alt="同步投影  智能测评" class="ty-text" src="@/assets/student/ty-text.png">
      </div>
    </div>
    <div class="student-ExaminationPaper" v-show="fileList.length > 0 || uploadReady">
      <div class="flex-align-center">
        <div class="student-class-name flex-align-between">
          <div class="dot"></div>
          <div>提交作品</div>
          <div class="dot"></div>
        </div>
      </div>
      <div class="flex-align-center upload-box ">
        <!-- v-if="fileList.length == 0" -->
        <el-upload v-show="fileList.length === 0" action="" :multiple="false" :show-file-list="false"
          :http-request="httpRequest" ref="upload">
          <div class="flex-column-center upload-send">
            <img alt="" class="upload-1" src="@/assets/student/upload-1.png">
            <div class="flex-align-center">
              <span class="text">上传图片</span>
              <img alt="" class="upload-2" src="@/assets/student/upload-2.png">
            </div>
          </div>
        </el-upload>
        <!-- v-else -->
        <template>
          <div class="flex-column-center upload-show" v-for="(item, index) in fileList" :key="index" v-loading="loading"
            element-loading-text="识别中...">
            <img alt="" class="upload-close" src="@/assets/student/upload-close.png" @click="delUpliad">
            <div>
              <img alt="" class="upload-file" :src="item">
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from 'element-ui';
const OSS = require('ali-oss');
export default {
  components: {},
  name: "StudentWork",
  data() {
    return {
      numPages: null,
      selectedStudent: null,
      UploadStatus: false,
      // numPages: null,
      // selectedStudent: null,
      isSubmit: true,
      fileList: [],
      uploadId: null,
      intervalId: null,
      failStatus: null,
      failList: {
        2: "oss文件下载错误",
        3: '二维码未找到',
        4: "识别发生异常",
        5: "没有匹配到字",
        6: '空白的字格',
        7: "字形模板文件不存在",
        8: "作品图不完整或不清晰",
        9: "条形码未识别",
        10: "非本次测评卷"
      },
      loading: false,
      evalNum: null,
      /** 校验与 OSS 就绪后为 true，展示上传区；用户第二次点击「上传图片」选图（兼容 iOS） */
      uploadReady: false
    };
  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async goUpload() {
      let data = {
        testId: this.$route.query.testId
      }
      let resData = await this.$Api.StuTest.checkStatus(data);
      console.log('查询教师上下课状态', resData);
      if (resData.data == 0) {
        this.$message.error('测评未开始，请稍后再试！');
        return
      }
      if (resData.data == 2) {
        this.$message.error('测评已结束·');
        return
      }
      try {
        await this.initOss();
        this.uploadReady = true;
      } catch (e) {
        console.error(e);
        this.$message.error('初始化上传失败，请重试');
      }
    },
    async logout() {
      let data = `testId=${this.$route.query.testId}&studentId=${this.$route.query.studentId}`
      let resData = await this.$Api.StuTest.classOut(data);
      console.log('学生端下课:', resData);
      this.$message.success('退出成功');
      let classId = sessionStorage.getItem('padClassId');
      let t = sessionStorage.getItem('padT');
      let teacherId = sessionStorage.getItem('padTeacherId');
      setTimeout(() => {
        this.$router.push({
          path: '/student/classMates',
          query: {
            testId: this.$route.query.testId,
            classId,
            t,
            teacherId
          }
        });
      }, 1000);
    },
    async initOss() {//初始化oss
      let resData = await this.$Api.Upload.getQueryToken();
      // console.log('获取ossTpken:', resData);
      this.client = new OSS({
        region: 'oss-cn-beijing',
        authorizationV4: true,
        accessKeyId: resData.data.accessKeyId, // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeySecret: resData.data.accessKeySecret,
        stsToken: resData.data.stsToken,// 从STS服务获取的安全令牌（SecurityToken）。
        bucket: resData.data.bucket,// 填写Bucket名称，例如examplebucket。
        timeout: 60000 * 60 * 24
      })
    },
    httpRequest(data) {
      // console.log('自定义上传方法:', data);
      const localUrl = URL.createObjectURL(data.file);
      this.fileList.push(localUrl);
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      const timestamp = currentDate.getTime() + '_' + Math.floor(Math.random() * 10000) + 1;
      let name = `static/import/upload/${year}/${month}/${day}/sync-pad-identify-upload-${timestamp}.${data.file.type.split("/")[1]}`
      this.client.put(name, data.file)
        .then(res => {
          // console.log('上传成功:', res);
          this.loading = true;
          this.uploadStuWork(name);
        })
        .catch(err => {
          console.log('上传失败:', err)
        })
    },
    // 上传作品
    async uploadStuWork(filePath) {
      let data = {
        studentId: this.$route.query.studentId,
        testId: this.$route.query.testId,
        classId: this.$route.query.classId,
        filePath,
        teacherId: this.$route.query.teacherId
      }
      let resData = await this.$Api.StuTest.uploadStuWork(data);
      console.log('上传作品结果:', resData);
      this.uploadId = resData.data;
      this.queryWork();
    },
    // 查询作品状态
    queryWork() {
      let data = {
        uploadId: this.uploadId
      }
      this.intervalId = setInterval(async () => {
        let resData = await this.$Api.StuTest.queryWork(data);
        console.log('查询作品状态:', resData);
        if (resData.data.status == 0) {
          clearInterval(this.intervalId);
          this.queryWork()
          return
        }
        if (resData.data.status == 1) {
          this.loading = false;
          this.isSubmit = false;
          clearInterval(this.intervalId);
          this.submitUpload();
        } else {
          this.failStatus = resData.data.status;
          // this.$message.error(this.failList[resData.data.status]);
          this.$alert(`识别失败，${this.failList[resData.data.status]}，请重新拍照`, '提示', {
            confirmButtonText: '确定',
          });
          this.UploadStatus = false;
          // this.loading = false;
          // this.isSubmit = false;
          this.isSubmit = true;
          this.fileList = [];
          this.uploadId = null;
          this.failStatus = null;
          this.loading = false;
          clearInterval(this.intervalId);
        }
      }, 5000);

    },
    // 删除作品
    delUpliad() {
      this.fileList = [];
      if (this.intervalId) {
        console.log('清除定时器');
        // this.isSubmit = true;
        // this.loading = false;
        this.isSubmit = true;
        this.fileList = [];
        this.uploadId = null;
        this.failStatus = null;
        this.loading = false;
        this.UploadStatus = false;
        clearInterval(this.intervalId);
      }
    },
    // CancelUpload(){
    //   console.log('取消上传');

    // },
    // 提交作品
    async submitUpload() {
      if (this.fileList.length == 0) {
        this.$message.error('请先上传作品');
        return
      }
      let data1 = {
        testId: this.$route.query.testId,
      }
      let resData2 = await this.$Api.StuTest.getEvalNum(data1);
      console.log('获取当前测评次序', resData2);
      this.evalNum = resData2.data;

      let data = {
        uploadId: this.uploadId,
        testId: this.$route.query.testId,
        studentId: this.$route.query.studentId,
        evalNum: this.evalNum
      }
      let resData = await this.$Api.StuTest.addWork(data);
      console.log('提交作品结果:', resData);
      // this.$message({
      //   message: '提交成功',
      //   type: 'success',
      //   duration:0
      // });
      this.$message({
        dangerouslyUseHTMLString: true,
        message: '<span style="font-size: 26px;">提交成功</span>',
        type: 'success',
      });
      setTimeout(() => {
        this.$router.push({
          path: '/student/listWork',
          query: {
            testId: this.$route.query.testId,
            studentId: this.$route.query.studentId
          }
        });
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      console.log('清除定时器');
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style lang="less" scoped>
@import "student.less";

.student-Entrance {
  // border: 1px solid #000;
}

.student-ExaminationPaper {
  // border: 1px solid #000;
}

/deep/ .el-loading-text{
  font-size: 32px;
}

</style>
<style>
.class-name {
  padding: 70px 0;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 28px;
  text-align: center;
  gap: 20px;
}

.ty-box {
  gap: 50px;
}

.ty-button {
  width: 428px;
  height: 428px;
}

.ty-text {
  font-weight: 400;
  font-size: 52px;
  color: #999999;
  line-height: 62px;
  width: 460px;
}
.el-message .el-icon-success{
  font-size: 26px !important;
}
.el-message__icon{
  font-size: 26px !important;
}
.el-message__icon{
  font-size: 26px !important;
}
</style>
